import Immutable from "immutable";
export default {
    CREATE_DASHBOARD: (state, action) => {
        let id = action.payload.id;
        let data = Immutable.fromJS(action.payload);
        return state.set(id, data);
    },
    UPDATE_DASHBOARD: (state, action) => {
        let id = action.payload.id;
        let config = Immutable.fromJS(action.payload.config);
        let data = Immutable.fromJS(action.payload.data);
        return state.setIn([id, "config"], config).setIn([id, "data"], data);
    }
};
